import {useNavigate} from "react-router-dom";
import {Col, Row} from "antd";
import {BarChartOutlined, FileSearchOutlined, PhoneOutlined} from "@ant-design/icons";
import {SquareTile} from "../../components/home/squareTile/SquareTile";
import {RoutingURL} from "../../model/models";

export default function Reports() {
    const navigate = useNavigate();
    return (
        <>
            <Row gutter={[16, 16]} justify="center" className="home-container">
                <Col span={10}>
                    <SquareTile
                        title="Report Chiamate"
                        description="Generazione report del registro chiamate."
                        icon={<PhoneOutlined/>}
                        onCLick={() => navigate(RoutingURL.REPORT_CHIAMATE)}
                    />
                </Col>
                <Col span={10}>
                    <SquareTile
                        title="Report Rate"
                        description="Generazione report del rata "
                        icon={<BarChartOutlined/>}
                        onCLick={() => navigate(RoutingURL.REPORT_RATE)}
                    />
                </Col>
                <Col span={10}>
                    <SquareTile
                        title="Report Incassi"
                        description="Generazione report incassi"
                        icon={<FileSearchOutlined/>}
                        onCLick={() => navigate(RoutingURL.REPORT_INCASSI)}
                    />
                </Col>
            </Row>
        </>
    )
}